// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PlayerDetails__name___hq7d7 {
    font-size: 24px;
    margin-bottom: 10px;
}

.PlayerDetails__moreDetails___M6hWB {
    margin-bottom: 10px;
}

.PlayerDetails__label___D1IuH {
    color: gray;
    margin-right: 5px;
}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"name": `PlayerDetails__name___hq7d7`,
	"moreDetails": `PlayerDetails__moreDetails___M6hWB`,
	"label": `PlayerDetails__label___D1IuH`
};
module.exports = ___CSS_LOADER_EXPORT___;
